export class HtmlHelper
{
    /**
     * Экранирует значение для вставки в HTML (текст и атрибуты в кавычках): данные сторонних сайтов
     * в ячейках таблиц выводятся через v-html и без экранирования исполнились бы как разметка
     * @param value {*}
     * @returns {string}
     */
    static escape(value)
    {
        return String(value ?? '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }
}
